import { adobeLaunch } from "vg-fas-adobe-launch";
const fileRegEx = /([a-zA-Z0-9_-]+)\.([^.]*)$/gm; //Regex spec: https://regex101.com/r/nfk7mE/4

const trackContentDownload = (e) => {
	const getFileData = (str) => {
		const groups = fileRegEx.exec(str);
		fileRegEx.lastIndex = 0;

		if (!groups) {
			return {};
		}

		return { fileName: groups[1], fileType: groups[2] };
	};

	const downloadItem = e.currentTarget;
	const fundId = downloadItem.dataset.fundId;
	const litId = downloadItem.dataset.litId
		? `lit:${downloadItem.dataset.litId}`
		: null;

	let fileName = "none";
	let fileType = "none";

	if (downloadItem.href) {
		const fileData = getFileData(downloadItem.href);
		fileName = fileData.fileName;
		fileType = fileData.fileType;
	}
	if (downloadItem.dataset.filePath) {
		// Note: No `else` on purpose in case the developers wants to have an `href` and still generate a different event
		const fileData = getFileData(downloadItem.dataset.filePath);
		fileName = fileData.fileName;
		fileType = fileData.fileType;
	}

	adobeLaunch.trackContentDownloaded(`${fileType}:${fileName}`, litId, fundId);
};

export default {
	methods: {
		listenToElements: () => {
			const elArr = Array.prototype.slice.call(
				document.querySelectorAll("[data-content-download]")
			);
			elArr.forEach((downloadItem) => {
				// Remove click events if they already exist to avoid event duplication
				downloadItem.removeEventListener("click", trackContentDownload, true);
				// Add click events
				downloadItem.addEventListener("click", trackContentDownload, true);
			});
		}
	},
	mounted() {
		window.addEventListener("load", () => {
			//Wait until page is fully loaded
			setTimeout(() => {
				this.listenToElements();
			}, 1000);
		});
	},
	updated() {
		this.$nextTick(function () {
			this.listenToElements();
		});
	}
};
